// sagas.js
import { takeLatest, put, call } from "redux-saga/effects";
import * as types from "../../actionTypes";
import AxiosInstance from "../../../services/AxiosInstance";
import { fetchStatesSuccess,fetchStatesFailure } from "./actions";

function* fetchStates(action) {
  try {
    
    // Call your API function here with action.payload.keyword
    const response = yield call(() =>
      AxiosInstance().post("/fetch_states", action.payload)
    );
    if(response.data.status){

      yield put(fetchStatesSuccess(response.data));
    }else{
      yield put(fetchStatesFailure(response.data));
    }
  } catch (error) {
    // Dispatch failure action with the error
    yield put(fetchStatesFailure({status:false,message:error.message}));
  }
}

// Watch for the latest FETCH_LOCATIONS_REQUEST action and call the saga
function* fetchStatesSaga() {
  yield takeLatest(types.FETCH_STATES_REQUEST, fetchStates);
}

export default fetchStatesSaga;
